import { render, staticRenderFns } from "./view-pixel.vue?vue&type=template&id=603254b8&scoped=true"
import script from "./view-pixel.vue?vue&type=script&lang=js"
export * from "./view-pixel.vue?vue&type=script&lang=js"
import style0 from "./view-pixel.vue?vue&type=style&index=0&id=603254b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603254b8",
  null
  
)

export default component.exports